import React, { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import "./webhooksTable.css";
import { getAllMerchnatWebhooks } from "../../../config/LiveApi";
import { FaEdit } from "react-icons/fa";
import EditWebhookModal from "./Modal";
import DataTable from "../../../components/common/DataTable/DataTable";
import DateCell from "../../../components/common/TableCells/DateCell";

const WebhooksTable = () => {
  const token = useSelector((store) => store.userReducer.token);
  const [isLoading, setIsLoading] = useState(false);
  const [merchantWebhooks, setMerchantWebhooks] = useState([]);
  const [selectedWebhook, setSelectedWebhook] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const fetchWebhooks = useCallback(async () => {
    setIsLoading(true);

    try {
      const response = await getAllMerchnatWebhooks(token);

      setMerchantWebhooks(
        response?.data?.filter((webhook) => webhook.role === "admin") || [],
      );
    } catch {
      toast.error("Failed to fetch merchant webhooks.");
    } finally {
      setIsLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchWebhooks();
  }, [fetchWebhooks]);

  const handleEditClick = (webhook) => {
    setSelectedWebhook(webhook);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedWebhook(null);
  };

  const columns = [
    {
      key: "merchantName",
      header: "Merchant Name",
      wrapCell: true,
    },
    {
      key: "payinURL",
      header: "Payin URL",
      wrapCell: true,
    },
    {
      key: "payoutURL",
      header: "Payout URL",
      wrapCell: true,
    },
    {
      key: "createdAt",
      header: "Created At",
      render: (row) =>
        row.createdAt ? <DateCell date={row.createdAt} /> : "N/A",
    },
    {
      key: "updatedAt",
      header: "Updated At",
      render: (row) =>
        row.updatedAt ? <DateCell date={row.updatedAt} /> : "N/A",
    },
    {
      key: "action",
      header: "Action",
      render: (row) => (
        <FaEdit
          style={{
            cursor: "pointer",
          }}
          onClick={() => handleEditClick(row)}
        />
      ),
    },
  ];

  return (
    <div className="webhooks-report-table-container">
      <h2 className="webhooks-report-table-title">Merchant Webhooks</h2>
      <DataTable
        columns={columns}
        data={merchantWebhooks}
        loading={isLoading}
        emptyMessage="No admin merchants webhooks found."
      />

      {showModal && selectedWebhook && (
        <EditWebhookModal
          webhook={selectedWebhook}
          token={token}
          onClose={closeModal}
          onUpdate={fetchWebhooks}
        />
      )}
    </div>
  );
};

export default WebhooksTable;
